<template lang="html">
  <div>
    <v-row class="d-flex flex-nowrap justify-start align-center" align="center">
      <div class="mx-3 ml-3 px-0">
        ROI<sub>ETH</sub>  <span class="factor">{{ roiFactorETH | toInt(2, 'x') }}</span>
      </div>

      <div>
        ROI<sub>USD</sub>  <span class="factor">{{ roiFactorUSD | toInt(2, 'x') }}</span>
      </div>
    </v-row>
  </div>
</template>

<script>
import {
    mapState
  } from 'vuex';

  export default {
    data() {
      return {
        // currentPriceETH: 0,
        // currentPriceUSD: 0,
        // currentPriceChange24hETH: 0,
        // currentPriceChange24hUSD: 0,
        // currentPriceChange24hETHClass: "changeUp",
        // currentPriceChange24hUSDClass: "changeUp",
        initialPriceETH: 55900.80344143941383017 / 260760440.016238701274314313,
        initialPriceUSD: 55900.80344143941383017 / 260760440.016238701274314313 * 747.35,
        roiFactorUSD: 0,
        roiFactorETH: 0,
      }
    },
    computed: {
      ...mapState({
        currentUniswapStats: state => state.currentUniswapStats,
        currentETHPrice: state => state.currentETHPrice,
        // coingeckoStats: state => state.coingeckoStats
      }),
    },
    mounted() {
      this.updatePriceData();
    },
    watch: {
      currentUniswapStats() {
        this.updatePriceData();
      },
      currentETHPrice() {
        this.updatePriceData();
      },
      // coingeckoStats() {
      //   this.updatePriceData();
      // }
    },
    methods: {
      updatePriceData() {
        let currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
        let currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
        this.roiFactorUSD = currentPriceUSD / this.initialPriceUSD;
        this.roiFactorETH = currentPriceETH / this.initialPriceETH;
      },
    }

  }
</script>

<style lang="css" scoped>
</style>
